import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import QuickformTabs from "./components/QuickformTabs.vue";
import { VDialog } from "v-ferry-components";
import SvgSprite from "@/components/icons/SvgSprite.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SvgSprite),
    _createVNode(QuickformTabs),
    _createVNode(_unref(VDialog))
  ], 64))
}
}

})